import script from "./OkrTitleFiled.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrTitleFiled.vue?vue&type=script&setup=true&lang=js"

import "./OkrTitleFiled.vue?vue&type=style&index=0&id=70089146&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70089146"]])

export default __exports__